/**
 * Notion 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <NotionIcon className="w-8 h-8" />
 * <NotionIcon className="w-12 h-12" />
 * ```
 */
export function NotionIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Notion icon"
      role="img"
    >
      <title>Notion</title>
      <g id="Notion">
        <path
          id="Vector"
          d="M7.65587 6.90899C8.53131 7.6165 8.85972 7.56251 10.5036 7.45341L26.0014 6.52767C26.33 6.52767 26.0566 6.20146 25.9472 6.14725L23.3732 4.29622C22.8801 3.91534 22.223 3.47912 20.9637 3.58824L5.95725 4.67709C5.40998 4.73107 5.30065 5.00327 5.51863 5.22149L7.65587 6.90899ZM8.58633 10.502V26.7237C8.58633 27.5955 9.02426 27.9217 10.01 27.8678L27.042 26.8874C28.0281 26.8335 28.138 26.2336 28.138 25.5256V9.41266C28.138 8.70559 27.8647 8.32427 27.2609 8.3787L9.46223 9.41266C8.80541 9.46756 8.58633 9.79442 8.58633 10.502ZM25.4003 11.3721C25.5096 11.8626 25.4003 12.3526 24.9064 12.4077L24.0858 12.5703V24.5462C23.3732 24.9272 22.7162 25.145 22.1687 25.145C21.2922 25.145 21.0726 24.8726 20.416 24.0565L15.0481 15.6733V23.7844L16.7467 24.1656C16.7467 24.1656 16.7467 25.145 15.3763 25.145L11.5983 25.3629C11.4886 25.145 11.5983 24.6011 11.9815 24.492L12.9674 24.2203V13.4961L11.5986 13.387C11.4888 12.8965 11.7622 12.1894 12.5295 12.1345L16.5824 11.8628L22.1687 20.3551V12.8425L20.7444 12.6799C20.6351 12.0804 21.0726 11.645 21.6203 11.591L25.4003 11.3721ZM4.69727 3.20736L20.3065 2.06385C22.2234 1.9003 22.7164 2.00986 23.9213 2.88048L28.9038 6.36434C29.726 6.96344 30 7.12654 30 7.77962V26.8874C30 28.0847 29.5615 28.793 28.0283 28.9013L9.90152 29.9904C8.75064 30.0449 8.2029 29.8817 7.6002 29.1191L3.9309 24.3832C3.27341 23.5114 3 22.8591 3 22.0961V5.11196C3 4.13266 3.43862 3.31581 4.69727 3.20736Z"
          fill="black"
        />
      </g>
    </svg>
  );
}
